// MEMASUKAN MODUL DARI REACT
import React from "react";
// MEMASUKAN MODUL DARI FRAMER MOTIOn
import { motion } from "framer-motion";
// MENGMASUKAN MODUL PENGHIAS YANG SAYA BUAT
import {
  LapisanWadah,
  MelenturkanWadah,
  Tajuk,
  Teks,
  TeksBiru,
  WadahIkon,
} from "../styles/Menyeluruh.styled";
import { KartuKeahlian, WadahKeahlian } from "../styles/KeahlianSaya.styled";
import { Keahlian } from "../utils/Data";
import { PariasiHilangKeKiri, PariasiHilangKeKanan } from "../utils/Pariasi";

const KeahlianSaya = () => {
  return (
    <LapisanWadah
      id="Keahlian"
      atas="10%"
      bawah="10%"
      kiriResponsif="1rem"
      kananResponsif="1rem"
    >
      <MelenturkanWadah
        melenturkanResponsif
        arahResponsif="column-reverse"
        ukuranLebar
      >
        {/* -----KEAHLIAN BAGIAN KIRI----- */}
        <WadahKeahlian
          as={motion.div}
          variants={PariasiHilangKeKiri}
          initial="hilang"
          whileInView="ada"
        >
          {Keahlian.map((keahlian) => (
            <KartuKeahlian>
              <WadahIkon ukuran="5rem" warna="biru">
                {keahlian.ikon}
              </WadahIkon>

              <Tajuk as="h4" ukuran="t4">
                {keahlian.nama}
              </Tajuk>
            </KartuKeahlian>
          ))}
        </WadahKeahlian>

        {/* -----KEAHLIAN BAGIAN KANAN----- */}
        <motion.div
          variants={PariasiHilangKeKanan}
          initial="hilang"
          whileInView="ada"
        >
          <Tajuk as="h4" ukuran="t4">
          MY SKILLS
          </Tajuk>
          <Tajuk as="h2" ukuran="t2" atas="0.5rem">
          What Are  <TeksBiru>My Skills</TeksBiru>
          </Tajuk>

          <Teks atas="2rem" bawah="1.5rem">
          As a Community Builder and Testnet Validator, I continuously enhance my skills to foster vibrant communities and ensure the integrity of blockchain networks. I actively engage with community members to share knowledge, provide support, and promote participation in various projects. All the skills I acquire will be documented on GitHub for easy access if you’re curious about my learning progress.
          </Teks>

          <Teks>
          This portfolio serves as a space for me to showcase the projects I’ve worked on throughout my journey as a Community Builder, Testnet Validator, and web developer, covering both <TeksBiru>Client Side</TeksBiru> and{" "}
            <TeksBiru>Server Side</TeksBiru>.
          </Teks>
        </motion.div>
      </MelenturkanWadah>
    </LapisanWadah>
  );
};

export default KeahlianSaya;
